import _ from 'lodash';

const parseWarrantyLines = (linesData) =>
  linesData.map((lineData) => {
    const warrantyLine = linesData.find(
      (i) => lineData.displayLineNumber === i.warrantyForDisplayLineNumber
    );

    return {
      ...lineData,
      warrantyLine,
    };
  });

const parsePackageLines = (linesData) =>
  linesData.reduce((parsedLines, lineData) => {
    if (!lineData.isRootItem) {
      return parsedLines;
    }

    const bomLines = _.uniqWith(
      linesData.filter((i) => i.bomForDisplayLineNumber === lineData.displayLineNumber),
      (lineA, lineB) => lineA.displayLineNumber === lineB.displayLineNumber
    );

    return [
      ...parsedLines,
      {
        ...lineData,
        bomLines,
      },
    ];
  }, []);

const parseOrderLines = (linesData = []) => {
  // Makes sure any warranted line have its warrantyLine associated in the object
  const warrantedLines = parseWarrantyLines(linesData);

  // Creates a structure of root items with the associated BOM lines as children
  const parsedLines = parsePackageLines(warrantedLines);

  return parsedLines.sort((line, nextLine) =>
    parseInt(line.displayLineNumber) > parseInt(nextLine.displayLineNumber) ? 1 : -1
  );
};

const getShippedQuantity = (lineData = {}) => {
  if (lineData.isPackage) {
    const packageFullyShipped = lineData.bomLines.every(
      (line) =>
        line.totalOrderedQty === line.totalShippedQty ||
        line.totalOrderedQty === line.lineShippedQty
    );

    return packageFullyShipped ? lineData.totalOrderedQty : '*';
  } else {
    return lineData.totalShippedQty || lineData.lineShippedQty || 0;
  }
};

export { parseOrderLines, getShippedQuantity };
